<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormRow class="mb-4" :required="true">
          <template #label>Asset</template>
          <template #field>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.asset.$error ? 'multiselect--error' : ''"
              :disabled="!formCreate"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Choose asset"
              :showLabels="false"
              @input="chooseAsset"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.asset.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.asset.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Member / ID</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                v-model="formData.account"
                :options="listAccount"
                :loading="listAccountLoading"
                :close-on-select="true"
                :hide-selected="false"
                :allow-empty="false"
                :class="$v.formData.account.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="tooltip"
                tag-placeholder="Press enter to choose"
                placeholder="Search member"
                :showLabels="false"
                :internal-search="false"
                :searchable="formCreate"
                :disabled="!formCreate"
                @search-change="getListAccount"
                @input="chooseAccount"
              >
                <template #noOptions v-if="formData.asset"
                  >Search member in {{ formData.asset.name }}.</template
                >
                <template #noOptions v-else
                  >Please select asset first.</template
                >
                <template #noResult v-if="formData.asset"
                  >No results found.</template
                >
                <template #noResult v-else>Please select asset first.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.account.required"
                  >This field is required.</span
                >
              </div>
            </div>
            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="formData.member_account.aname"
              />
            </div>
          </template>
          <template #help>
            <span v-if="formCreate"
              >Search by ID, username or member's bank account</span
            >
            <button
              type="button"
              class="button button--primary mt-2"
              v-if="formData.account"
              v-clipboard:copy="formData.account.panel_id"
            >
              Copy {{ formData.account.panel_id }}
            </button>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Bonus Amount</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.amount.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              type="text"
              class="form__input"
              placeholder="Bonus Amount"
              v-model="formData.amount"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.amount.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.amount.required"
                >One of these fields is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Rolling Amount</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.rolling.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              type="text"
              class="form__input"
              placeholder="Rolling Amount"
              v-model="formData.rolling"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.rolling.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.rolling.required"
                >One of these fields is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Cashback Amount</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.cashback.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              type="text"
              class="form__input"
              placeholder="Cashback Amount"
              v-model="formData.cashback"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.cashback.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.cashback.required"
                >One of these fields is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Panel Date</template>
          <template #field>
            <date-picker
              v-model="formData.date"
              type="datetime"
              :editable="false"
              :clearable="false"
              :show-seconds="false"
              input-class="form__input"
              value-type="YYYY-MM-DD HH:mm:ss"
              format="DD MMMM YYYY - HH:mm"
              time-title-format="DD MMM YYYY"
              placeholder="Panel Date / Time"
              :disabled-date="notAfterToday"
              :class="{
                'form__input--error': $v.formData.date.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
            ></date-picker>
            <div
              class="form-error"
              v-if="$v.formData.date.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.date.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Note</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Note"
              rows="5"
              v-model="formData.note"
              :class="{
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
            ></textarea>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>Status</template>
          <template #field>
            <div class="flex">
              <button
                v-if="currentStatus == 0"
                class="border-gray-600 button border border-solid hover:bg-gray-600 hover:text-white transition-all mr-2 duration-200 text-left"
                :class="
                  !formData.status || formData.status == '0'
                    ? 'bg-gray-600 text-white'
                    : 'text-gray-600'
                "
                type="button"
                @click="setStatus(0)"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'question-circle']" />
                  Pending</span
                >
              </button>
              <button
                v-if="currentStatus != 2"
                class="border-green-500 button border border-solid hover:bg-green-500 hover:text-white transition-all duration-200 mr-2 text-left"
                :class="
                  formData.status == '1'
                    ? 'bg-green-500 text-white'
                    : 'text-green-500'
                "
                @click="setStatus(1)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'check-circle']" />
                  Approve</span
                >
              </button>
              <button
                v-if="!formCreate"
                class="border-red-500 button border border-solid hover:bg-red-500 hover:text-white transition-all duration-200 text-left"
                :class="
                  formData.status == '2'
                    ? 'bg-red-500 text-white'
                    : 'text-red-500'
                "
                @click="setStatus(2)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'times-circle']" />
                  Reject</span
                >
              </button>
            </div>
          </template>
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field v-if="currentStatus != 2">
            <BaseButton class="mr-2" type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div>
              <template v-if="currentStatus != 2">or</template>
              <router-link
                :to="{ name: 'BonusList' }"
                class="link"
                :class="{
                  'ml-2': currentStatus != 2,
                }"
                >Back to List Bonus</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import { datePickerMixin } from "@/mixins/datePickerMixin";
import { CurrencyDirective, parse } from "vue-currency-input";
import { required, requiredIf } from "vuelidate/lib/validators";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";
import { getListBankOptionsMixin } from "@/mixins/getListBankOptionsMixin";

import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

const prettyPrintJson = require("pretty-print-json");

export default {
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [
    getListAssetMixin,
    submitFormMixin,
    getListBankOptionsMixin,
    datePickerMixin,
  ],
  components: {
    Multiselect,
    DatePicker,
  },
  data: () => {
    return {
      listAsset: [],
      listAssetLoading: false,
      listAccount: [],
      listAccountLoading: false,

      listLogs: [],
      listLogsLoading: true,

      currentStatus: "",

      formData: {
        asset: null,
        note: "",
        account: null,
        date: null,
      },
    };
  },
  validations: {
    formData: {
      asset: {
        required,
      },
      account: {
        required,
      },
      amount: {
        required: requiredIf(function () {
          return !this.formData.rolling && !this.formData.cashback;
        }),
      },
      rolling: {
        required: requiredIf(function () {
          return !this.formData.amount && !this.formData.cashback;
        }),
      },
      cashback: {
        required: requiredIf(function () {
          return !this.formData.rolling && !this.formData.amount;
        }),
      },
      date: {
        required,
      },
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint
        : "/" + this.$route.meta.endpoint + "/" + this.formData.id;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint;
    },
  },
  created() {
    if (this.formCreate || !this.formData.asset) {
      this.listAssetLoading = true;
      this.getListAsset();
    }

    this.formData.amount = 0;
    this.formData.rolling = 0;
    this.formData.cashback = 0;

    this.$_debounceTimer = null;

    this.formData.date = this.dateformat(new Date());
  },
  methods: {
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;

        const method = this.formCreate ? "post" : "patch";
        const url = process.env.VUE_APP_API_URL + this.submitUrl;

        this.$store.commit("toggleLoading");

        this.$http({
          method: method,
          url: url,
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push({ name: this.$route.meta.baseRoute }, () => {
                this.$swal({
                  position: "bottom-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                  title: res.data.message,
                  icon: "success",
                });
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
    chooseAsset(selectedOption) {
      this.formData.asset_id = selectedOption.id;

      this.clearListAccount();
    },
    calculateBalance() {
      if (!this.formData.amount) this.formData.amount = 0;
      if (!this.formData.amount) this.formData.amount = 0;
      if (!this.formData.before_credit) this.formData.before_credit = 0;

      const amount = parse(this.formData.amount);
      const bonus = parse(this.formData.amount);
      const before_credit = parse(this.formData.before_credit);

      if (isNaN(amount) || isNaN(bonus) || isNaN(before_credit)) {
        this.newCreditBalance = "Error";
      } else {
        this.newCreditBalance = Intl.NumberFormat("en", {
          minimumFractionDigits: 2,
        }).format(amount + bonus + before_credit);
      }
    },
    clearListAccount() {
      this.listAccount = [];
      this.formData.account = null;
    },
    chooseAccount(selectedOption) {
      this.formData.member_account_id = selectedOption.id;
    },
    printJson(data) {
      return data ? prettyPrintJson.toHtml(JSON.parse(data)) : "-";
    },
    getListLogs() {
      this.$http
        .get(
          process.env.VUE_APP_API_URL + this.$route.path.replace("edit", "log")
        )
        .then((res) => {
          if (res.status == 200) {
            this.listLogsLoading = false;

            const response = res.data;

            if (response) {
              this.listLogs = response;
            }
          }
        })
        .finally(() => {});
    },
    setStatus(status) {
      this.formData.status = status;
    },
    dateformat(date, format = "YYYY-MM-DD HH:mm:ss") {
      return this.moment(date).format(format);
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;

            this.formData = { ...this.formData, ...data };
            this.formData.asset = data.member_account.asset;

            this.formData.account = data.member_account;
            this.currentStatus = data.status;

            this.formReady = true;
          }
        })
        .catch((err) => {
          // console.log(err);
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    getListAccount(query) {
      if (this.formData.asset && query.length >= 3) {
        this.debounce(() => {
          this.listAccountLoading = true;
          this.$http
            .get(
              process.env.VUE_APP_API_URL +
                "/member-account?asset_id=" +
                this.formData.asset.id +
                "&search=" +
                query
            )
            .then((res) => {
              if (res.status == 200) {
                const response = res.data;

                if (response) {
                  this.listAccount = response.data;
                }
              }
            })
            .finally(() => {
              this.listAccountLoading = false;
            });
        }, 500);
      }
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
  },
};
</script>
